import { useQuery } from '@tanstack/react-query'

import { formatCurrency } from '../../utils/format-helpers'
import { useIsStore } from '../../auth/utils'
import { StatCard, StatCardSkeleton } from './components/stat-card'
import {
  fetchRoiGroupsGoal,
  fetchUserGoalSalesMonth,
  fetchUserGoalSalesWeek,
} from './stats/api'

function HomeRoi() {
  const { isFaherty } = useIsStore()

  const roiStat = useQuery({
    queryKey: ['home roi stat'],
    queryFn: fetchRoiGroupsGoal,
    enabled: Boolean(isFaherty()),
  })

  const monthlySalesGoal = useQuery({
    queryKey: ['monthly sales goal'],
    queryFn: fetchUserGoalSalesMonth,
  })

  const weeklySalesGoal = useQuery({
    queryKey: ['weekly sales goal'],
    queryFn: fetchUserGoalSalesWeek,
  })

  return (
    <>
      {roiStat.data ? (
        <>
          {/* TODO: INDEX KEY */}
          {roiStat.data.data.map((d, index) => {
            const roi = formatCurrency(d.roi, { abbreviate: true })
            const goal = formatCurrency(d.goal, { abbreviate: true })
            return (
              <StatCard key={index} label="2024 Goal" stat={`${roi}/${goal}`} />
            )
          })}
        </>
      ) : roiStat.error ? (
        <StatCard
          label="2024 Goal"
          stat={
            roiStat.error instanceof Error
              ? roiStat.error.message
              : 'Unknown error.'
          }
        />
      ) : roiStat.isInitialLoading ? (
        <StatCardSkeleton />
      ) : null}

      {weeklySalesGoal.data ? (
        weeklySalesGoal.data.goal ? (
          <>
            <StatCard
              label="Weekly Sales Goal"
              stat={`${formatCurrency(
                weeklySalesGoal.data.sales
              )}/${formatCurrency(weeklySalesGoal.data.goal)}`}
            />
          </>
        ) : null
      ) : (
        <StatCardSkeleton />
      )}

      {monthlySalesGoal.data ? (
        monthlySalesGoal.data.goal ? (
          <>
            <StatCard
              label="Monthly Sales Goal"
              stat={`${formatCurrency(
                monthlySalesGoal.data.sales
              )}/${formatCurrency(monthlySalesGoal.data.goal)}`}
            />
          </>
        ) : null
      ) : (
        <StatCardSkeleton />
      )}
    </>
  )
}

export { HomeRoi }
